var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "el-drawer-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "nav-manager",
        style: { "z-index": _vm.zIndex, left: _vm.containerLeft },
      },
      [
        _c("div", { staticClass: "nav-manager__content" }, [
          _c(
            "div",
            { staticClass: "nav-section" },
            [
              _c(
                "div",
                {
                  staticClass: "nav-section__title",
                  attrs: { title: "123123" },
                },
                [_vm._v("全部应用")]
              ),
              _vm._v(" "),
              _c(
                "flexbox",
                {
                  staticClass: "nav-section__content",
                  attrs: { wrap: "wrap" },
                },
                _vm._l(_vm.allList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "nav-section-item",
                      class: { "is-future": item.future },
                      on: {
                        click: function ($event) {
                          return _vm.selectClick(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "nav-section-item__icon" }, [
                        _c("i", { class: item.icon }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nav-section-item__label" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _vm._v(" "),
                      _vm.isEdit &&
                      _vm.topList.length < 8 &&
                      !item.future &&
                      !_vm.isHasSelect(item.module)
                        ? _c("i", {
                            staticClass: "el-icon-circle-plus is-handle",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.moduleTopClick(item, index)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.future
                        ? _c("span", { staticClass: "span-future" }, [
                            _vm._v(_vm._s(item.futureLabel)),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-section" },
            [
              _c(
                "div",
                { staticClass: "nav-section__title" },
                [
                  _vm._v("置顶应用"),
                  _c("span", { staticClass: "nav-section__tips" }, [
                    _vm._v("（最多可设置8个置顶应用，可通过拖拽进行排列）"),
                  ]),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveClick },
                        },
                        [_vm._v("保存")]
                      )
                    : _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.isEdit = !_vm.isEdit
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "draggable",
                {
                  staticClass: "vux-flexbox nav-section__content",
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: {
                    options: {
                      dragClass: "sortable-drag",
                      forceFallback: false,
                      disabled: !_vm.isEdit,
                    },
                  },
                  model: {
                    value: _vm.topList,
                    callback: function ($$v) {
                      _vm.topList = $$v
                    },
                    expression: "topList",
                  },
                },
                _vm._l(_vm.topList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "nav-section-item",
                      on: {
                        click: function ($event) {
                          return _vm.selectClick(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "nav-section-item__icon" }, [
                        _c("i", { class: item.icon }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nav-section-item__label" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c("i", {
                            staticClass: "el-icon-remove is-handle",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.topModuleDelete(item, index)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }